import { motion } from "framer-motion";

// Slow, continuous drifting/pulsing blur orb — used as ambient background
// motion across sections so the page never feels fully static.
export const AmbientOrb = ({
  className = "",
  color = "bg-gold-500/10",
  size = "h-[28rem] w-[28rem]",
  blur = "blur-[110px]",
  duration = 10,
  delay = 0,
}) => (
  <motion.div
    className={`pointer-events-none absolute rounded-full ${size} ${color} ${blur} ${className}`}
    animate={{
      x: [0, 30, -20, 0],
      y: [0, -25, 15, 0],
      scale: [1, 1.12, 0.96, 1],
    }}
    transition={{
      duration,
      delay,
      repeat: Infinity,
      ease: "easeInOut",
    }}
  />
);

// Drop-in pair of drifting orbs for section backgrounds.
export const AmbientOrbs = ({ variant = "light" }) => {
  const gold = variant === "dark" ? "bg-gold-500/10" : "bg-gold-500/[0.07]";
  const emerald = variant === "dark" ? "bg-emerald2-500/10" : "bg-emerald2-500/[0.06]";
  return (
    <>
      <AmbientOrb className="-left-40 top-16" color={gold} duration={11} />
      <AmbientOrb className="-right-24 top-1/2" color={emerald} size="h-96 w-96" duration={13} delay={1.5} />
    </>
  );
};
